export enum RefreshStatus {
  // A usable access token is available (freshly fetched or reused) — retry the original request.
  REFRESHED = 'REFRESHED',
  // The refresh genuinely failed (expired/invalid refresh token) — the session is over.
  FAILED = 'FAILED',
  // The server could not be reached (offline / request timeout / 5xx) — the session may still be
  // valid, so the cold-start bootstrap offers a "server unreachable, retry" screen instead of
  // bouncing to login. (At runtime the reauth query still treats this like FAILED — the safe direction.)
  UNREACHABLE = 'UNREACHABLE',
  // A logout aborted the refresh mid-flight — do nothing, the user is already leaving.
  CANCELLED = 'CANCELLED',
}

export type RefreshOutcome =
  | { status: RefreshStatus.REFRESHED; token: string }
  | { status: RefreshStatus.FAILED }
  | { status: RefreshStatus.UNREACHABLE }
  | { status: RefreshStatus.CANCELLED };
